import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import FusionCharts from 'fusioncharts';
import ReactFC from 'react-fusioncharts';

import CropFreeRoundedIcon from '@material-ui/icons/CropFreeRounded';
import { makeStyles } from '@material-ui/core/styles';

import Modal from 'components/Modal';
import WidgetButton from 'components/buttons/WidgetButton';
import NotesFullscreen from 'components/NotesWidget/components/NotesFullscreen';
import ButtonCloseMaximize from './components/ButtonCloseMaximize';

const useStyles = makeStyles({
  button: {
    padding: '0px'
  },
  icon: {
    fontSize: 'medium'
  }
});

const MaximizeButton = ({ children, widgetRef, id }) => {
  const classes = useStyles();

  const [isOpen, setIsOpen] = useState(false);

  const handleMaximizeClick = () => {
    setIsOpen(true);
  };

  const handleMaximizeClose = () => {
    setIsOpen(false);
  };

  const renderComponent = useCallback(() => {
    if (widgetRef.current && widgetRef.current.chartObj) {
      const clonedChartObj = new FusionCharts(widgetRef.current.chartObj.clone({}, true));
      clonedChartObj.setChartAttribute({ legendNumRows: null, exportShowMenuItem: true });

      return (
        <ReactFC
          type={clonedChartObj.options.chartType}
          {...clonedChartObj.options}
          width="100%"
          height="90%"
        />
      );
    }
    if (widgetRef.current && widgetRef.current.getAttribute('name') === 'notes') {
      return <NotesFullscreen id={id} />;
    }

    return children;
  }, [children, id, widgetRef]);

  return (
    <>
      <WidgetButton onClick={handleMaximizeClick}>
        <CropFreeRoundedIcon className={classes.icon} />
      </WidgetButton>

      <Modal isOpen={isOpen} closeModal={handleMaximizeClose}>
        {renderComponent()}
        <ButtonCloseMaximize handleClose={handleMaximizeClose} />
      </Modal>
    </>
  );
};

MaximizeButton.propTypes = {
  children: PropTypes.node,
  widgetRef: PropTypes.shape({ current: PropTypes.any }),
  id: PropTypes.number
};

MaximizeButton.defaultProps = {
  children: null,
  widgetRef: null,
  id: null
};

export default MaximizeButton;
